<div class="content-container automation-table" style="padding-bottom: 30px;">
  <div class="automation-table__toolbar mb-3">
    <div class="row g-2 align-items-end">
      <div class="col-12 col-xl">
        <div class="row g-2 align-items-end">
          <div class="col-12 col-md-auto">
            <label class="form-label mb-1">Date range:</label>
            <input
              type="date"
              class="form-control"
              [ngModel]="fromDate()"
              (ngModelChange)="onFromDateChange($event)"
            />
          </div>

          <div class="col-12 col-md-auto d-flex align-items-center justify-content-center automation-table__to">
            <span>to</span>
          </div>

          <div class="col-12 col-md-auto">
            <label class="form-label mb-1 d-none d-md-block">&nbsp;</label>
            <input
              type="date"
              class="form-control"
              [ngModel]="toDate()"
              (ngModelChange)="onToDateChange($event)"
            />
          </div>

          <div class="col-6 col-md-auto">
            <label class="form-label mb-1 d-none d-md-block">&nbsp;</label>
            <button type="button" class="btn btn-primary w-100" (click)="onApply()">
              Apply
            </button>
          </div>

          <div class="col-6 col-md-auto">
            <label class="form-label mb-1 d-none d-md-block">&nbsp;</label>
            <button type="button" class="btn btn-outline-secondary w-100" (click)="onClear()">
              Clear
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-auto">
        <div class="row g-2">
          <div class="col-12 col-md">
            <div class="input-group">
                <input
                  type="search"
                  class="form-control"
                  placeholder="Search"
                  [value]="searchValue()"
                  (keyup.enter)="search($any($event.target).value)"
                  (search)="search($any($event.target).value)"
                  #searchInput
                />

                <button
                  class="btn btn-primary"
                  type="button"
                  (click)="search(searchInput.value)"
                >
                  <i class="fa fa-search me-1"></i> Search
                </button>
              </div>
            </div>

          <div class="col-12 col-md-auto">
            
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="automation-table__stats mb-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div class="row g-2 flex-grow-1">
      <div class="col-6 col-md-auto">
        <div class="summary-card summary-card--neutral">
          <div class="summary-card__value">{{ totalJobs() }}</div>
          <div class="summary-card__label">Total Jobs</div>
        </div>
      </div>
      <div class="col-6 col-md-auto">
        <div class="summary-card summary-card--success">
          <div class="summary-card__value">{{ completedCount() }}</div>
          <div class="summary-card__label">Completed</div>
        </div>
      </div>
      <div class="col-6 col-md-auto">
        <div class="summary-card summary-card--warning">
          <div class="summary-card__value">{{ inProgressCount() }}</div>
          <div class="summary-card__label">In Progress</div>
        </div>
      </div>
      <div class="col-6 col-md-auto">
        <div class="summary-card summary-card--cancelled">
          <div class="summary-card__value">{{ cancelledCount() }}</div>
          <div class="summary-card__label">Cancelled</div>
        </div>
      </div>
      <div class="col-6 col-md-auto">
        <div class="summary-card summary-card--danger">
          <div class="summary-card__value">{{ failedCount() }}</div>
          <div class="summary-card__label">Failed</div>
        </div>
      </div>
    </div>

    <!-- RIGHT: Create Button -->
    <div class="ms-auto">
      <button type="button" class="btn btn-primary w-100" routerLink="/automation/generate-bulk-clone">
        <fa-icon class="button-icon-left" [icon]="faPlus"></fa-icon> 
        Create Job
      </button>
    </div>

  </div>

  <div class="automation-table__scroll" *ngIf="!isMobile()">
    <div class="automation-table__table-wrap">
      <table class="table table-hover align-middle automation-table__grid">
        <thead>
          <tr>
            <th>Job ID</th>
            <th>Created At</th>
            <th>Created By</th>
            <th class="text-center"># Single Projects</th>
            <th class="text-center"># MYA</th>
            <th class="text-center"># Expiring</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of pagedRows(); trackBy: trackByJobId">
            <td>{{ row.jobId }}</td>
            <td>{{ formatDate(row.createdAt) }}</td>
            <td>{{ row.createdBy }}</td>
            <td class="text-center">{{ row.singleProjects }}</td>
            <td class="text-center">{{ row.myaCount }}</td>
            <td class="text-center">{{ row.expiringCount }}</td>

            <td>
              <span
                class="status-pill"
                [ngClass]="{
                  'status-pill--success': row.status === 'completed',
                  'status-pill--warning': row.status === 'in_progress',
                  'status-pill--danger': row.status === 'failed'
                }"
              >
                <span class="status-pill__dot"></span>
                {{ getStatusLabel(row.status) }}
              </span>
            </td>

            <td>
              <button
                type="button"
                class="btn btn-link text-decoration-none automation-table__action"
                (click)="onViewDetails(row)"
              >
                View Details
              </button>
            </td>
          </tr>

          <tr *ngIf="pagedRows().length === 0">
            <td colspan="8" class="text-muted">No jobs found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row table-controls automation-table__footer mt-3">
      <div class="col">
        <div ngbDropdown placement="top-left" class="d-inline-block">
          <button class="btn btn-outline-primary" ngbDropdownToggle>
            <span>Page Size: </span> {{ limit() }}
          </button>

          <div ngbDropdownMenu class="page-size-dropdown">
            <button ngbDropdownItem (click)="setLimit(20)">20</button>
            <button ngbDropdownItem (click)="setLimit(50)">50</button>
            <button ngbDropdownItem (click)="setLimit(100)">100</button>
          </div>
        </div>
      </div>

      <div class="col">
        <ngb-pagination
          class="d-flex justify-content-end"
          *ngIf="totalCount() > 0"
          [page]="page()"
          [pageSize]="limit()"
          [collectionSize]="totalCount()"
          [boundaryLinks]="true"
          [maxSize]="10"
          [ellipses]="true"
          [rotate]="true"
          (pageChange)="setCurrentPage($event)"
        ></ngb-pagination>
      </div>
    </div>
  </div>

  <div class="scrollable" *ngIf="isMobile()">
    <ul class="list-group">
      <li *ngFor="let row of pagedRows(); trackBy: trackByJobId" class="list-group-item">
        <div class="d-flex justify-content-between align-items-start gap-3">
          <div>
            <div class="fw-semibold">{{ row.jobId }}</div>
            <div class="text-muted small">{{ formatDate(row.createdAt) }}</div>
          </div>

          <span
            class="status-pill"
            [ngClass]="{
              'status-pill--success': row.status === 'completed',
              'status-pill--warning': row.status === 'in_progress',
              'status-pill--danger': row.status === 'failed'
            }"
          >
            <span class="status-pill__dot"></span>
            {{ getStatusLabel(row.status) }}
          </span>
        </div>

        <div class="mt-3 mobile-job-grid">
          <div>
            <label class="form-label mb-1">Created By</label>
            <div>{{ row.createdBy }}</div>
          </div>

          <div>
            <label class="form-label mb-1"># Single Projects</label>
            <div>{{ row.singleProjects }}</div>
          </div>

          <div>
            <label class="form-label mb-1"># MYA</label>
            <div>{{ row.myaCount }}</div>
          </div>

          <div>
            <label class="form-label mb-1"># Expiring</label>
            <div>{{ row.expiringCount }}</div>
          </div>
        </div>

        <div class="mt-3">
          <button
            type="button"
            class="btn btn-link text-decoration-none px-0 automation-table__action"
            (click)="onViewDetails(row)"
          >
            View Details
          </button>
        </div>
      </li>

      <li *ngIf="pagedRows().length === 0" class="list-group-item">No jobs found</li>
    </ul>

    <div class="row table-controls automation-table__footer mt-3">
      <div class="col">
        <div ngbDropdown placement="top-left" class="d-inline-block">
          <button class="btn btn-outline-primary" ngbDropdownToggle>
            {{ limit() }}
          </button>

          <div ngbDropdownMenu class="page-size-dropdown">
            <button ngbDropdownItem (click)="setLimit(5)">5</button>
            <button ngbDropdownItem (click)="setLimit(10)">10</button>
            <button ngbDropdownItem (click)="setLimit(20)">20</button>
          </div>
        </div>
      </div>

      <div class="col">
        <ngb-pagination
          class="d-flex justify-content-end"
          *ngIf="totalCount() > 0"
          [page]="page()"
          [pageSize]="limit()"
          [collectionSize]="totalCount()"
          [boundaryLinks]="true"
          [maxSize]="1"
          [ellipses]="true"
          [rotate]="true"
          (pageChange)="setCurrentPage($event)"
        ></ngb-pagination>
      </div>
    </div>
  </div>
</div>